var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidbaricon1010Selected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04427 6.41667C9.04427 5.28908 8.13019 4.375 7.0026 4.375C5.87502 4.375 4.96094 5.28908 4.96094 6.41667C4.96094 7.54425 5.87502 8.45833 7.0026 8.45833C8.13019 8.45833 9.04427 7.54425 9.04427 6.41667Z",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0319 6.62078C9.21973 6.67771 9.41894 6.70833 9.62533 6.70833C10.7529 6.70833 11.667 5.79425 11.667 4.66667C11.667 3.53908 10.7529 2.625 9.62533 2.625C8.56663 2.625 7.69613 3.43082 7.59375 4.46258",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40918 4.46258C6.3068 3.43082 5.43631 2.625 4.3776 2.625C3.25002 2.625 2.33594 3.53908 2.33594 4.66667C2.33594 5.79425 3.25002 6.70833 4.3776 6.70833C4.58399 6.70833 4.78323 6.67771 4.97101 6.62078",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 9.62467C12.8333 8.01386 11.3969 6.70801 9.625 6.70801",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2057 11.3747C10.2057 9.76386 8.76933 8.45801 6.9974 8.45801C5.22548 8.45801 3.78906 9.76386 3.78906 11.3747",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3724 6.70801C2.60048 6.70801 1.16406 8.01386 1.16406 9.62467",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidbaricon1010Selected);
export default __webpack_public_path__ + "static/media/sidbaricon1010Selected.3811caa6c1e421ed8a74744cf8a26980.svg";
export { ForwardRef as ReactComponent };